import Cohere from 'cohere-js';
import { UserResponse } from '../providers/User/User.model';

export const addCohereIdentity = (userResponse: UserResponse): void => {
  Cohere.identify(
    userResponse.id, // Required: can be any unique ID
    {
      displayName: `${userResponse.first_name} ${userResponse.last_name}`, // Optional
      email: userResponse.email_address // Optional
    }
  );
};
